module.exports = __webpack_public_path__ + "img/homepage_2.6983628a.svg";